'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtStoreId', [
	'$stateParams',
	'$i18next',
	function ($stateParams) {
		return {
			restrict: 'A',
			replace: true,
			scope: {
				pmtStoreId: '@',
				locationId: '@',
				diffObject: '=',
				disableHeader: '@'
			},
			link: function (scope, element, attrs) {
				scope.site = $stateParams.site;

				scope.showHeader = true;
				attrs.$observe('pmtStoreId', function (newVal) {
					scope.storeId = newVal;
				});
				attrs.$observe('disableHeader', function (newVal) {
					scope.showHeader = !scope.$eval(newVal);
				});
			},
			templateUrl: 'shared/dataPrinters/pmtStoreIdView.html'
		};
	}
]);
